import React from 'react';
import {motion} from 'framer-motion';
import {PieChart,Pie,Cell,ResponsiveContainer,Legend,Tooltip} from 'recharts';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiGlobe,FiMapPin,FiTrendingUp}=FiIcons;

const GeographicReach=()=> {
  const geoData=[
    {name: 'United States',percentage: 23,color: '#00BCD4',flag: '🇺🇸'},
    {name: 'United Kingdom',percentage: 14,color: '#FF6B35',flag: '🇬🇧'},
    {name: 'Ireland',percentage: 11,color: '#4CAF50',flag: '🇮🇪'},
    {name: 'Canada',percentage: 8,color: '#9C27B0',flag: '🇨🇦'},
    {name: 'Other Countries',percentage: 44,color: '#FFC107',flag: '🌍'}
  ];

  const CustomTooltip=({active,payload})=> {
    if (active && payload && payload.length) {
      const data=payload[0].payload;
      return (
        <div className="glass-effect rounded-lg p-3 border border-white/20">
          <p className="text-white font-semibold flex items-center">
            <span className="mr-2">{data.flag}</span>
            {data.name}
          </p>
          <p className="text-proactuary-blue-200">{data.percentage}% of attendees</p>
        </div>
      );
    }
    return null;
  };

  return (
    <motion.div
      className="glass-effect rounded-2xl p-8"
      initial={{opacity: 0,y: 20}}
      animate={{opacity: 1,y: 0}}
      transition={{duration: 0.6}}
    >
      <div className="text-center mb-8">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{delay: 0.2}}
        >
          <SafeIcon icon={FiGlobe} className="text-proactuary-blue-400 mr-3" />
          Global Market Reach
        </motion.h2>
        <div className="w-24 h-1 bg-gradient-to-r from-proactuary-blue-500 to-proactuary-green-500 mx-auto rounded-full" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <motion.div
          className="h-96"
          initial={{opacity: 0,scale: 0.8}}
          animate={{opacity: 1,scale: 1}}
          transition={{delay: 0.3}}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={geoData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={120}
                fill="#8884d8"
                dataKey="percentage"
                animationBegin={0}
                animationDuration={1500}
              >
                {geoData.map((entry,index)=> (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend
                wrapperStyle={{color: 'white'}}
                formatter={(value,entry)=> `${entry.payload.flag} ${value}`}
              />
            </PieChart>
          </ResponsiveContainer>
        </motion.div>

        <div className="space-y-4">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
            <SafeIcon icon={FiMapPin} className="text-proactuary-green-400 mr-2" />
            Market Access Highlights
          </h3>

          {geoData.map((country,index)=> (
            <motion.div
              key={index}
              className="glass-effect rounded-xl p-4 border border-white/10 hover:border-white/30 transition-colors"
              initial={{opacity: 0,x: 20}}
              animate={{opacity: 1,x: 0}}
              transition={{delay: 0.4 + index * 0.1}}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">{country.flag}</span>
                  <div>
                    <div className="text-white font-semibold">{country.name}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold text-white">{country.percentage}%</div>
                  <div className="w-16 h-2 bg-white/20 rounded-full mt-1">
                    <motion.div
                      className="h-full rounded-full"
                      style={{backgroundColor: country.color}}
                      initial={{width: 0}}
                      animate={{width: `${(country.percentage / 44) * 100}%`}}
                      transition={{delay: 0.6 + index * 0.1,duration: 0.8}}
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        className="bg-gradient-to-r from-proactuary-blue-500/20 to-proactuary-green-500/20 rounded-xl p-6 mt-8 border border-proactuary-blue-500/30"
        initial={{opacity: 0,scale: 0.95}}
        animate={{opacity: 1,scale: 1}}
        transition={{delay: 0.8}}
      >
        <h3 className="text-xl font-bold text-white mb-3 flex items-center">
          <SafeIcon icon={FiTrendingUp} className="text-proactuary-blue-400 mr-2" />
          Global Market Reach
        </h3>
        <p className="text-white/90 leading-relaxed">
          Your sponsorship reached actuaries across major insurance markets including North America, Europe, Africa, and Asia. This broad professional audience represents diverse market opportunities and establishes your brand presence across key actuarial communities worldwide.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default GeographicReach;